import { upperFirst } from 'lodash';
import { useTranslation } from 'react-i18next';

import { PageLayout, PageTitle } from 'core/components';
import { SelectionCountProvider } from 'core/states';
import { CustomerQuoteList, VendorQuoteList } from 'quotes/components';
import { QuoteEntityType, QuoteType } from 'quotes/enums';

interface IProps {
  type: QuoteType;
}

export const OrderListPage = ({ type }: IProps) => {
  const { t } = useTranslation();

  const title = t(`title${upperFirst(type)}Orders`);

  return (
    <PageLayout title={title}>
      <SelectionCountProvider>
        <PageTitle title={title} />

        {QuoteType.CUSTOMER === type && <CustomerQuoteList entityType={QuoteEntityType.ORDER} />}

        {QuoteType.VENDOR === type && <VendorQuoteList entityType={QuoteEntityType.ORDER} />}
      </SelectionCountProvider>
    </PageLayout>
  );
};
